<template>
  <div class="c-input-url">
    <div v-if="url" class="c-input-url__origin">
      <p>{{ url | hyphenToNonBreakingHyphen | removeTrailingSlash }}</p>
    </div>
    <div class="c-input-url__path c-alertPos">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      required: false
    }
  }
};
</script>
